import {uniq} from 'lodash';
import {connect} from 'react-redux';

import {getPushConfig} from '../../../libs/shared/core/src/store/data/config/configSelectors';
import {PushControllerProvider} from '../../../libs/shared/ui/src/push/pushControllerProvider';
import {getCompany} from '../../../src/store/data/company/companySelectors';
import {getUser} from '../../../src/store/data/teammates/teammatesSelectors';
import {getAnalyticsPanelsRooms} from '../../../src/store/panels/analytics/analyticsPanelSelectors';
import {getCellsPanelsRooms} from '../../../src/store/panels/cells/cellsPanelSelectors';
import {getComposerPanelsRooms} from '../../../src/store/panels/composer/composerPanelSelectors';
import {getViewerPanelsRooms} from '../../../src/store/panels/viewer/viewerPanelSelectors';
import {createSelector, makeMapStateToProps} from '../../helpers/reselectHelpers';

const getChannels = createSelector(
  [getCellsPanelsRooms, getViewerPanelsRooms, getComposerPanelsRooms, getAnalyticsPanelsRooms],
  (cellsPanelsRooms, viewerPanelsRooms, composerPanelsRooms, analyticsPanelsRooms) =>
    uniq([...cellsPanelsRooms, ...viewerPanelsRooms, ...composerPanelsRooms, ...analyticsPanelsRooms]),
);

const mapStateToProps = makeMapStateToProps()(() => ({
  pushConfig: getPushConfig,
  company: getCompany,
  user: getUser,
  channels: getChannels,
}));

export const PushControllerProviderContainer = connect(mapStateToProps, {})(PushControllerProvider);
